export default [
    {
        name: 'snowFloor',
        type: 'gltfModel',
        path: 'models/snow_ground/scene.gltf'
    },

    {
        name: 'candyHouse',
        type: 'gltfModel',
        path: 'models/candy_house/scene.gltf'
    },
    {
        name: 'snowTree',
        type: 'gltfModel',
        path : 'models/snow_tree/scene.gltf'
    },
    {
        name: 'candyCane',
        type: 'gltfModel',
        path : 'models/candy_cane/scene.gltf'
    },
    {
        name: 'fence',
        type: 'gltfModel',
        path : 'models/fence/scene.gltf'
    },
    {
        name: 'christmasTree',  
        type: 'gltfModel',
        path: 'models/christmas_tree/scene.gltf'
    },
    {
        name: 'santaSleigh',
        type: 'gltfModel',
        path: 'models/santa_sleigh/scene.gltf'
    },
    {
        name: 'snow',
        type: 'texture',
        path: 'textures/particles/snow.png'
    },
    {
        name:'snowMusic',
        type: 'music',
        path: 'audio/music-snow.mp3'
    }
]